import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export default function ThemeToggle() {
  const [dark, setDark] = useState(() => localStorage.getItem("rr-theme") === "dark");

  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("rr-theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <button
      data-testid="theme-toggle"
      onClick={() => setDark((d) => !d)}
      title={dark ? "Switch to light" : "Switch to Dark Pro"}
      className="h-9 w-9 flex items-center justify-center rounded-full border border-border text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors"
    >
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
